module.exports = __webpack_public_path__ + "img/img2.278a6234.jpg";